import { OTATokenCookie } from '@/enums/cookies'
import { getCookie } from '@/utils/cookies'

export function shouldFetchOTA() {
  return !!getCookie(OTATokenCookie)
}
